import { IConfig } from '@cian/config/shared';
import { AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC } from 'shared/map-search/constants/config/experiments';
import { IExperiment } from 'shared/map-search/types/experiments';
import { isAbUseExperimentActive } from 'shared/map-search/utils/experiments';

const DEFAULT_RESULTABLE_PRECISION = 7;

type TParams = {
  config: IConfig;
  experiments: IExperiment[];
  isDesktop: boolean;
  precision: number;
};

export function isResultablePrecision({ config, experiments, isDesktop, precision }: TParams): boolean {
  const isExperimentActive = isAbUseExperimentActive(experiments, AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, 'B');

  const resultablePrecision =
    (isExperimentActive && isDesktop && config.get<number>('mapSearchFrontend.resultablePrecision')) ||
    DEFAULT_RESULTABLE_PRECISION;

  return precision >= resultablePrecision;
}
